<script lang="ts">
    import { onMount } from 'svelte';
    import { page } from '$app/stores';

    onMount(() => {
        if ($page.status === 404 && window.location.hostname !== 'localhost') {
            window.location.href = 'https://factlines.com';
        }
    });
</script>

<div>
    <div class="w-full max-w-xl flex flex-col mt-[15vh]">
        <h1>Error {$page.status}</h1>

        <p class="mb-4">{$page.error?.message}</p>

        <p class="mb-4"><a href="/">Go to start page</a></p>
    </div>
</div>
